<div class="outer w-100">
    <div class="sliders" [items]="fitems">
        <app-nav-panel class="d-block w-100" [CID]="cid"></app-nav-panel>
    </div>
</div>

<router-outlet></router-outlet>